// PORTUGUÊS

export default {
    values: {
        'Type to search': 'Digite para buscar',
        REMOVE: 'REMOVER',
        Remove: 'Remover',
        Creating: 'Criando',
        Create: 'Criar',
        Close: 'Fechar',
        Cancel: 'Cancelar',
        'Confirm deletion': 'Confirmar deleção',
        'No, I do not': 'Não tenho certeza',
        of: 'de',
        items: 'itens',
        Default: 'Padrão',
        Ascending: 'Ascendente',
        Descending: 'Descendente',
        All: 'Tudo',
        Description: 'Descrição',
        Name: 'Nome',
        Save: 'Salvar',
        Asset: 'Ativo',
        ASSET: 'ATIVO',
        Responsible: 'Responsável',
        'Live Event Id': 'ID de evento do LIVE',
        'Live Event ID': 'ID de evento do LIVE',
        'LIVE Event ID': 'ID de evento do LIVE',
        Showing: 'Mostrando',

        /* ---------------------------------------------------------------------------------------------------------- */

        // FETCH ERROR
        'An error occurred on get operations.': 'Ocorreu um erro ao buscar as operações.',
        'An error occurred on create diagram.': 'Ocorreu um erro ao criar o diagrama.',
        'An error occurred on list bowties.': 'Ocorreu um erro ao buscar a lista de bowties.',
        'An error occurred on get barrier status.': 'Ocorreu um erro ao buscar o status das barreiras.',
        'An error occurred on get bowtie.': 'Ocorreu um erro ao buscar o bowtie.',
        'Diagram saved successfully.': 'Diagrama salvo com sucesso.',
        'Error on save barrier.': 'Erro ao salvar a barreira.',
        'Error on save bowtie.': 'Erro ao salvar o bowtie.',
        'An error occurred on register supervisor': 'Ocorreu um erro ao registrar o novo supervisor',
        // END FETCH ERROR

        /* ---------------------------------------------------------------------------------------------------------- */

        // FETCH SUCCESSFULLY
        'Error on save diagram.': 'Erro ao salvar o diagrama.',
        'Barrier saved successfully.': 'Barreira salva com sucesso.',
        'Bowtie saved successfully.': 'Bowtie salvo com sucesso.',
        // END FETCH SUCCESSFULLY

        /* ---------------------------------------------------------------------------------------------------------- */

        // BOWTIE GENERAL
        THREAT: 'AMEAÇA',
        Threats: 'Ameaças',
        Threat: 'Ameaça',
        threat: 'ameaça',

        Barriers: 'Barreiras',
        Bowties: 'Bowties',
        Diagrams: 'Diagramas',

        PREVENTION: 'PREVENÇÃO',
        Prevention: 'Prevenção',

        HAZARD: 'PERIGO',
        Hazard: 'Perigo',

        MITIGATION: 'MITIGAÇÃO',
        Mitigation: 'Mitigação',

        CONSEQUENCE: 'CONSEQUÊNCIA',
        Consequences: 'Consequências',
        Consequence: 'Consequência',
        consequence: 'consequência',

        'Top Event': 'Evento Topo',
        'TOP EVENT': 'EVENTO TOPO',
        TOPEVENT: 'EVENTO TOPO',

        'Initial Freq.': 'Freq. Inicial',
        'Final Freq.': 'Freq. Final',
        'Tolerable Freq.': 'Freq. Tolerável',
        'Threshold Freq.': 'Freq. Limite',

        BARRIER: 'BARREIRA',
        BARRIERS: 'BARREIRAS',
        Barrier: 'Barreira',

        'Refresh Barriers': 'Recarregar Barreiras',

        'ESCALATION FACTOR': 'FATOR DE ESCALONAMENTO',
        'Escalation Factor': 'Fator de Escalonamento',
        'Escalation Factors': 'Fatores de Escalonamento',
        'Enabled degradation criteria:': 'Critérios de degradação ativados:',

        Marine: 'Marítimo',
        Drilling: 'Perfuração',
        Emergency: 'Emergência',
        marine: 'Marítimo',
        drilling: 'Perfuração',
        operation: 'Operação',
        emergency: 'Emergência',

        'System ID': 'ID do Sistema',
        'system id': 'id do sistema',
        'Mandatory Barrier': 'Barreira Mandatória',
        'Hide frequency on threats and consequences': 'Esconder frequências de ameaças e consequências',
        'Show frequency on threats and consequences': 'Mostrar frequências de ameaças e consequências',
        // END BOWTIE GENERAL

        /* ---------------------------------------------------------------------------------------------------------- */

        // RISK MANAGEMENT EDITOR
        Active: 'Ativa',
        'All Operations': 'Todas as Operações',
        'Select Resource': 'Selecione o Recurso',
        RESOURCE: 'RECURSO',
        Resources: 'Recursos',
        'Leave without saving': 'Sair sem salvar',
        'CONTROL BARRIER': 'BARREIRA DE CONTROLE',
        'Barrier Category': 'Categoria de Barreira',
        'barrier categories': 'categorias de barreira',
        Criticality: 'Criticidade',
        Criticity: 'Criticidade',
        'LIST OF ENTITIES': 'LISTA DE ENTIDADES',
        Operation: 'Operação',
        OPERATION: 'OPERAÇÃO',
        'Risk Management': 'Gestão de Risco',
        'Risk Diagram': 'Diagrama de Risco',
        'This action cannot be undone.': 'Esta ação não pode ser desfeita.',
        'Features that read this list will be affected.': 'Funcionalidades que utilizam esta lista serão afetadas.',
        'in the field below before completing the action:': 'no campo abaixo antes de completar a ação:',
        'Bowtie Editor': 'Editor Bowtie',
        'YOU DO NOT HAVE PERMISSION TO ACCESS THE EDITOR.': 'VOCÊ NÃO POSSUI PERMISSÃO PARA ACESSAR O EDITOR.',
        'YOU DO NOT HAVE PERMISSION TO ACCESS THE BOWTIE SETTINGS.':
            'VOCÊ NÃO POSSUI PERMISSÃO PARA ACESSAR AS CONFIGURAÇÕES DE BOWTIE.',

        'Are you sure you want to leave without saving your work?':
            'Tem certeza que deseja sair sem salvar seu trabalho?',

        /// RISK MANAGEMENT EDITOR - DIAGRAMS LIST
        'New Diagram': 'Novo Diagrama',
        'Create new diagram': 'Criar novo diagrama',
        'There are no diagrams yet': 'Ainda não há diagramas',
        'Are you sure you want remove the diagram': 'Tem certeza que quer remover o diagrama',
        'If you really want to delete the diagram, type': 'Se realmente quer deletar o diagrama, digite',
        'Delete diagram': 'Deletar diagrama',
        'diagram deleted.': 'Diagrama deletado.',
        /// End RISK MANAGEMENT EDITOR - DIAGRAMS LIST

        /// RISK MANAGEMENT EDITOR - BARRIERS LIST
        'New Barrier': 'Nova Barreira',
        'Are you sure you want remove the barrier': 'Tem certeza que quer remover a barreira',
        'If you really want to delete the barrier, type': 'Se realmente quer deletar a barreira, digite',
        'Delete barrier': 'Deletar barreira',
        'Load more': 'Carregar mais',

        'barrier deleted.': 'Barreira deletada.',
        'Please insert a different name when copying barrier':
            'Ao copiar uma barreira, favor inserir um nome diferente do original',
        'There are no barriers yet': 'Ainda não há barreiras',
        'Create new barrier': 'Criar nova barreira',
        /// End RISK MANAGEMENT EDITOR - BARRIERS LIST

        /// RISK MANAGEMENT EDITOR - BOWTIE LIST
        'New Bowtie': 'Novo Bowtie',
        'Create new Bowtie': 'Criar novo Bowtie',
        'There are no Bowties yet': 'Ainda não há Bowties',
        'Are you sure you want remove the bowtie': 'Tem certeza que quer remover o bowtie',
        'If you really want to delete the bowtie, type': 'Se realmente quer deletar o bowtie, digite',
        'Delete bowtie': 'Deletar bowtie',
        'bowtie deleted.': 'Bowtie deletado.',
        /// END RISK MANAGEMENT EDITOR - BOWTIE LIST

        /// RISK MANAGEMENT EDITOR - DIAGRAM EDITOR
        'A risk diagram must have at least one threat and at least one consequence.':
            'O diagrama de risco deve ter ao menos uma Ameaça e uma Consequência.',
        'Threat must have a valid name': 'A Ameaça deve ter um nome valido',
        'Consequence must have a valid name': 'A Consequência deve ter um nome valido',
        'must have a valid name': 'deve ter um nome válido',
        'Threat must have a valid initial frequency': 'A Ameaça deve ter uma frequência válida',
        'must have a valid initial frequency': 'deve ter uma frequência inicial válida',
        'must have a valid threshold frequency': 'deve ter uma frequência limite válida',
        'Top event must have a valid name': 'O Evento Topo deve ter um nome válido',
        'Hazard must have a valid name': 'O Perigo deve ter um nome válido',
        'Value Between 0 and 1': 'Valor entre 0 e 1',
        'Initial Frequency': 'Frequência Inicial',
        'Final Frequency': 'Frequência Final',
        'Initial PFD': 'PFD Inicial',
        'Final PFD': 'PFD Final',
        Missing: 'Falta(m)',
        'a valid name': ' um nome válido',
        'a valid initial frequency': 'uma frequência inicial válida',
        'a valid threshold frequency': 'uma frequência limite válida',
        'Missing a valid name': 'Falta um nome válido',
        'NEW THREAT NAME': 'NOVO NOME DE AMEAÇA',
        'NEW CONSEQUENCE NAME': 'NOVO NOME DE CONSEQUÊNCIA',
        'INITIAL FREQUENCY VALUE': 'VALOR DE FREQUÊNCIA INICIAL',
        'THRESHOLD FREQUENCY VALUE': 'VALOR DE FREQUENCIA LIMITE',
        'For a semi-qualitative bowtie, use Threshold Freq. with value 1':
            'Para bowties semi qualitativos, use Freq. Limite com valor 1',
        'For a semi-qualitative bowtie, use Initial Freq. with value 1':
            'Para bowties semi qualitativos, use Freq. Inicial com valor 1',

        /// END RISK MANAGEMENT EDITOR - DIAGRAM EDITOR

        /// RISK MANAGEMENT EDITOR - BARRIER EDITOR
        'Please select barrier category and barrier': 'Por favor, selecione a categoria de barreira e a barreira',
        'Entities with errors': 'Entidades com erro',
        'Barrier Update Mode': 'Modo de Atualização de Barreira',
        Method: 'Método',
        Quantitative: 'Quantitativo',
        Qualitative: 'Qualitativo',
        'NORMALIZATION TITLE': 'QUANTIZADOR',
        'add escalation': 'adicionar escalonamento',
        Deadline: 'Tempo limite',
        'Manual barrier is on indefinitely unless deadline is set.':
            'Barreira manual acionada indefinidamente, a menos que o tempo limite seja definido',
        'Manual Barrier Status Interaction': 'Barreira com status de interação manual',
        'External Related Links': 'Links externos relacionados',
        Label: 'Etiqueta',
        'Add Link': 'Adicionar Link',
        'Semi qualitative': 'Semi qualitativo',
        'name (should not be equal)': 'nome (não deveria ser igual)',

        /// END RISK MANAGEMENT EDITOR - BARRIER EDITOR

        /// RISK MANAGEMENT EDITOR - BOWTIE EDITOR
        'Safety Critical Barrier (Optional)': 'Barreira Crítica para Segurança (Opcional)',
        'Bowtie Mandatory Barrier': 'Mandatória para o Bowtie (Pré-Operacional)',
        'Threat Mandatory Barrier': 'Mandatória para a Ameaça',
        'Consequence Mandatory Barrier': 'Mandatória para a Consequência',
        'Once The Threat Mandatory Barrier option is selected the inactivation of it will lead to the inactivation of the whole Bowtie Web that it belongs. \nOnce The Bowtie Mandatory Barrier option is selected the inactivation of it will lead to the Top Event Occurrence directly, because it is an operational prerequisite':
            'Uma vez que a opção de barreira mandatória para a ameaça é selecionada, a inativação da mesma vai levar a inativação de todo a cadeia de Bowtie a qual pertence. \nUma vez que a opção de barreira mandatória para o Bowtie é selecionada, a inativação da mesma vai levar a ocorrencia do Evento Topo diretamente, pois é um pré-requisito operacional',
        'Once The Consequence Mandatory Barrier option is selected the inactivation of it will lead to the Top Event Occurrence directly, because it is an operational prerequisite':
            'Uma vez que a opção de barreira mandatória para a Consequência é selecionada, a inativação da mesma vai levar a ocorrencia do Evento Topo diretamente, pois é um pré-requisito operacional',
        'Changes made in this interface will occur just in this Bowtie':
            'Mudanças realizadas nesta interface ocorrerão apenas neste Bowtie',
        'Notified Groups': 'Grupos Notificados',
        'at least one barrier': 'pelo menos uma barreira',
        'barrier-removal-message': 'Tem certeza que deseja remover a %{type} %{name} do bowtie?',
        /// END RIS MANAGEMENT EDITOR - BOWTIE EDITOR
        // END RISK MANAGEMENT EDITOR

        /* ---------------------------------------------------------------------------------------------------------- */

        // BOWTIE VISUALIZATION
        'Degraded Barriers': 'Barreiras Degradadas',
        'active barriers': 'barreiras ativas',
        'Inactive Barriers': 'Barreiras Inativas',
        'Effectiveness Top': 'Limite Superior',
        'Effectiveness Bottom': 'Limite Inferior',
        'Refers to the quantity of barriers with any degradation (including the inactive ones).':
            'Refere a quantidade de barreiras com qualquer degradação (incluindo as inativas).',
        'Refers to the % of barriers that are not inactive and/or unknown status.':
            'Refere a % de barreiras que não estão inativas e/ou não possuem status desconhecido.',
        'No event': 'Sem evento',
        // END BOWTIE VISUALIZATION

        /* ---------------------------------------------------------------------------------------------------------- */

        /* OVERVIEW */
        degraded: 'degradada',
        Degraded: 'Degradada',
        Inactive: 'Inativa',
        inactive: 'inativa',
        INACTIVE: 'INATIVA',
        ACTIVE: 'ATIVA',
        DEGRADED: 'DEGRADADA',
        active: 'ativo',
        MANAGER: 'GERENTE',
        Unknown: 'Desconhecido',
        'BOWTIES WITH DEGRADED BARRIERS': 'BOWTIES COM BARREIRAS DEGRADADAS',
        'Go to bowtie editor': 'Ir para o Editor Bowtie',
        Acceptable: 'Aceitável',
        Tolerable: 'Tolerável',
        Unacceptable: 'Inaceitável',
        Evidences: 'Evidências',
        Intolerable: 'Intolerável',
        'Invalid event': 'Evento inválido',
        'inactive barriers': 'barreiras inativas',
        'This is a custom client overview. It does not follow the original product standard.':
            'Overview customizado para cliente. Não segue o padrão original do produto.',
        'Choose how you want to export this cards:': 'Escolha como você quer exportar esses cards:',
        'Closed card': 'Card fechado',
        'Open card': 'Card aberto',
        ' Inactive barriers': ' Barreiras inativas',
        'Confirm export': 'Confirmar exportação',
        /* END OVERVIEW */

        /* HELP MODAL */
        Help: 'Ajuda',
        'Bowtie interaction': 'Interação com o Bowtie',
        'human barrier': 'barreira humana',
        'physical barrier': 'barreira física',
        'administrative barrier': 'barreira organizacional',
        'High criticality': 'Alta criticidade',
        'Identifies a critical barrier.': 'Identifica uma barreira crítica.',
        'Dashboard action items': 'Itens de ação do dashboard',
        'Toggle language': 'Mudar idioma',
        'Open help modal': 'Abrir modal de ajuda',
        'Highlight inactive and unknown barriers': 'Destacar barreiras inativas e desconhecidas',
        'Open first barriers level': 'Abrir barreiras de primeiro nível',
        'Close all barriers': 'Fechar todas as barreiras',
        'Reset zoom and position': 'Redefinir zoom e posição',
        'Zoom in': 'Ampliar zoom',
        'Zoom out': 'Reduzir zoom',
        'Reset zoom': 'Redefinir zoom',
        'Edit this bowtie': 'Editar este bowtie',
        Search: 'Buscar',
        Settings: 'Configurações',
        'Go to Settings': 'Ir para Configurações',

        /** EXPORT / IMPORT */

        'You are about to associate data in order to create bowties.':
            'Você está prestes a associar dados para criar Bowties.',
        'This process requires that barriers and risk diagrams are already created and you have their ids.':
            'Esse processo requer que barreiras e diagramas de risco já estejam criadas e tenham identificadores.',
        " If you haven't read it yet, please refer to the Import Guide on the Installation Manual by clicking ":
            ' Caso ainda não tenha lido, consulte o Guia de Importação no Manual de Instalação clicando ',
        here: 'aqui',
        ' Please consider that this data association is a process that needs to be done thoroughlly or it will result in an error.':
            ' Por favor considere que essa associação de dados é um processo que precisa ser feito minuciosamente ou resultará em um erro.',
        'We advise you to read the Import Guide and to get familiar with the import models.':
            'Aconselhamos a leitura do Guia de Importação e a familiarização com os modelos de importação.',

        'You are about to import barrier data.': 'Você está prestes a importar dados de Barreira.',
        'Please consider that importing data is a process that needs to be done thoroughlly or it will result in an error. ':
            'Por favor considere que a importação de dados é um processo que precisa ser feito minuciosamente ou resultará em um erro.',

        'You are about to import risk diagram data.': 'Você está prestes a importar dados de Diagrama de Risco.',

        /** SETTINGS */
        'Alarp Description':
            'ALARP significa "tão baixo quanto razoavelmente praticável" e está diretamente relacionado ao Risco Residual. ALARP mostra uma imagem do nível de segurança que foi considerado naquele momento e é uma definição de nível de tolerância: inaceitável, tolerável e totalmente aceitável.',
        'Quantitative Description':
            'Dados quantitativos são usados para quantificar um problema por números. Esses dados podem ser contados ou comparados em uma escala numérica. O método quantitativo contém número para quantificar a PFD - Probabilidade de Falha sob Demanda - baseada no valor relativo de PFD Inicial (acima de 100%).',
        'Qualitative Description':
            'O método qualitativo pode ser definido por dados não númericos ou percentuais. CR - Critério - é utilizado para classificar uma faixa percentual em um bowtie qualitativo. O resultado do processo do método qualitativo será um status de degradação.',
        'Absolute Quantitative Description':
            'Dados quantitativos são utilizados para quantificar um problema por números. Esses dados podem ser contados ou comparados em uma escxala numérica. O método quantitativo contém números para quantificar o PFD - Probabilidade de Falha sob Demanda - baseado nas faixas de valores de PFD entre 0 e 1.',
        'QUANTITATIVE METHOD': 'MÉTODO QUANTITATIVO',
        'QUALITATIVE METHOD': 'MÉTODO QUALITATIVO',
        'NORMALIZATION METHOD':
            'Este valor subjetivo chamado QLR - resultado qualitativo - é quantificado em PFD - Probabilidade de Falha sob Demanda - a partir da configuração dada pelo usuário.',
        CATEGORY_UNMONITORED_DESCRIPTION:
            'Esta categoria corresponde a barreiras que não são monitoradas (em geral de terceiros) seja por sensor, por evento, manualmente ou outro método de atualização. Ou seja, o usuário não recebe nenhuma atualização de dados em tempo real.',
        ICON: 'ÍCONE',
        CATEGORY: 'CATEGORIA',
        DESCRIPTION: 'DESCRIÇÃO',
        AUTHOR: 'AUTOR',
        'LAST CHANGED': 'ÚLTIMA ATUALIZAÇÃO',
        'New Category': 'Nova Categoria',
        'Delete category': 'Excluir categoria',
        'Barrier Categories': 'Categorias de Barreira',
        'ALARP Levels': 'Níveis de ALARP',
        'Alarp Thresholds updated successfully.': 'Os limites ALARP foram atualizadas com sucesso.',
        'ALARP LEVELS FOR QUANTITATIVE BOWTIE': 'NÍVEL DE ALARP DE BOWTIE QUANTITATIVO',
        'ALARP LEVELS FOR SEMI-QUALITATIVE BOWTIE': 'NÍVEL DE ALARP DE BOWTIE SEMI QUALITATIVO',
        'Select qualitative default 1': 'Selecione semi qualitativo default 1',
        'Select qualitative default 2': 'Selecione semi qualitativo default 2',
        Color: 'Cor',
        'Highest acceptable level of risk': 'Nível de risco mais alto aceitável',
        'Generally acceptable level of risk': 'Nível de risco geralmente aceitável',
        'Risk Rate': 'Taxa de Risco',
        'New Rule': 'Nova Regra',
        Unmonitored: 'Não Monitorada',
        'Unmonitored Description':
            'Obs.: Por ser uma barreira sem monitoramento, esta categoria não exige cálculo de status. Por esta razão, não será possível configurar regras de negócio e os campos relativos aos intervalos de PFD estarão desabilitados na interface. Elas possuirão um status único, que receberá o mesmo nome da categoria, junto a cor específica para sua identificação.',
        'É necessário alterar o tipo de sistema para absoluto ou relativo antes de continuar':
            'É necessário alterar o tipo de sistema para absoluto ou relativo antes de continuar',
        'PFD variation': 'Variação de PFD',
        Above: 'Acima de',
        'no CR': 'sem CR',
        'no PFD': 'sem PFD',
        'In this mode, you must have at least two active barriers in each threat plot to have a risk acceptance level (ALARP) as ACCEPTABLE. For the INTOLERABLE risk acceptance level to be obtained, all prevention barriers must be inactive. All mitigation barriers must also be inactive for the consequence to occur.':
            'Neste modo você deverá ter no mínimo duas barreiras ativas em cada trama de ameaça para se ter um nível de aceitação de risco (ALARP) como ACEITÁVEL.  Já para que o nível de aceitação de risco  INACEITÁVEL seja obtido todas as barreiras de prevenção devem estar inativas. Da mesma forma, para que ocorra a consequência, todas as barreiras de mitigação devem estar inativas também.',
        'In this mode, you must have at least one 100% active barrier in each threat layer to have a risk acceptance level (ALARP) as ACCEPTABLE. For the INTOLERABLE risk acceptance level to be obtained, all prevention barriers must be inactive. All mitigation barriers must also be inactive for the consequence to occur.':
            'Neste modo você deverá ter pelo menos uma barreira 100% ativa em cada trama de ameaça para se ter um nível de aceitação de risco (ALARP) como ACEITÁVEL. Já para que o nível de aceitação de risco INACEITÁVEL seja obtido todas as barreiras de prevenção devem estar inativas. Da mesma forma, para que ocorra a consequência, todas as barreiras de mitigação devem estar inativas também.',
        'Barrier Category updated successfully.': 'Status de categoria de barreira atualizado com sucesso.',
        'Normalization updated successfully.': 'Normalização atualizada com sucesso.',
        'Barrier Status': 'Status de Barreira',
        'default name:': 'nome padrão:',
        'Barrier status custom names updated successfully.':
            'Nome customizado de status de barreira foi salvo com sucesso.',
        "You can't inactivate this status": 'Você não pode inativar este status',
        'Click to inactivate this status': 'Clique para inativar este status',
        'Click to activate this status': 'Clique para ativar este status',
        'Barrier Category Status updated successfully.': 'Status da Categoria de Barreira atualizado com sucesso.',
        'Are you sure you want remove the category': 'Tem certeza que deseja remover a categoria',
        'If you really want to delete the category, type': 'Se realmente deseja deletar a categoria, digite',
        /** REPORTS **/
        REPORTS: 'RELATÓRIOS',
        Report: 'Relatório',
        SETTINGS: 'CONFIGURAÇÕES',
        PRESETS: 'MODELOS DE RELATÓRIO',
        'Risk Acceptance / Risk Level': 'Nível de aceitação / Nível de Risco',
        'Resource Threat Status': 'Status da Ameaça do Recurso',
        'Resource Consequence Status': 'Status da Consequência do Recurso',
        'Resource Barrier Status': 'Status da Barreira do Recurso',
        'Resource Barrier PFD': 'PFD da Barreira do Recurso',
        'Current Mandatory Barriers': 'Barreira Mandatória Vigente',
        'Manual Interaction Barriers Status': 'Status da Barreira de Interação Manual',
        TIMESPAN: 'SELETOR DE TEMPO',
        Start: 'Início',
        End: 'Final',
        to: 'até',
        resource: 'recurso',
        'bowtie code': 'código do bowtie',
        'BOWTIE CODE': 'CÓDIGO DE BOWTIE',
        'Bowtie Code': 'Código de Bowtie',
        'bowtie name': 'nome do bowtie',
        'risk level status': 'nível de risco',
        'date/time': 'data/hora',
        'YYYY/MM/DD': 'AAAA/MM/DD',
        'threat name': 'nome da ameaça',
        'inherent risk': 'risco inerente',
        Yesterday: 'Ontem',
        'Last day': 'Último dia',
        'Last 15 days': 'Últimos 15 dias',
        'Last week': 'Última semana',
        'Last month': 'Último mês',
        'Last quarter': 'Último trimestre',
        'Last semester': 'Último semestre',
        'Last year': 'Último ano',
        Apply: 'Aplicar',
        Clear: 'Limpar',
        page: 'página',
        'All time': 'Todo tempo',
        'Select a preset and a time range to view a report':
            'Selecione um modelo pré definido e um intervalo de tempo para visualisar o relatório',
        'initial frequency': 'frequência inicial',
        'final frequency': 'frequência final',
        'barrier id': 'id da barreira',
        'barrier name': 'nome da barreira',
        'safety critical': 'segurança crítica',
        responsible: 'responsável',
        'Selected filters': 'Filtros selecionados',
        'Clear  all': 'Limpar todos',
        category: 'categoria',
        'entity name': 'nome da entidade',
        'initial pfd': 'pfd inicial',
        'final pfd': 'pfd final',
        threshold: 'limite',
        'Threshold Frequency': 'Frequência Limite',
        'PFD Max': 'PFD Máx',
        'Lowly degraded': 'B.Degradada',
        LOW_DEGRADED: 'B.DEGRADADA',
        HIGHLY_DEGRADED: 'A.DEGRADADA',
        HIGH_DEGRADED: 'A.DEGRADADA',
        'Highly degraded': 'A.Degradada',
        unmonitored: 'não monitorada',
        UNMONITORED: 'NÃO MONITORADA',
        'Resource Barrier Analysis': 'Análise da Barreira do Recurso',
        'time interval': 'intervalo de tempo',
        'Time Interval': 'Intervalo de tempo',
        'time gathered': 'tempo reunido',
        'Select an item from the list to view the graphic': 'Selecione um item da lista para visualizar o gráfico',
        Graphic: 'Gráfico',
        END: 'FINAL',
        START: 'INÍCIO',
        'Clear all filter view': 'Limpar todos os filtros',
        'Filters removed successfully.': 'Filtros removidos com sucesso.',
        'consequence name': 'nome da consequência',
        'threshold frequency': 'frequência limite',
        'There is no data for the specified period.': 'Não há dados no período especificado.',
        /** BarrierStatusCustomName */
        'ALTERAÇÃO das nomeclaturas de STATUS DE barreiras': 'ALTERAÇÃO das nomeclaturas de STATUS DE barreiras',
        'O sistema possibilita a alteração das nomeclaturas padrões utilizados no status de barreiras. As corres padrões não podem ser alteradas.':
            'O sistema possibilita a alteração das nomeclaturas padrões utilizados no status de barreiras. As corres padrões não podem ser alteradas.',
        'ATENÇÃO : ': 'ATENÇÃO : ',
        'Ao alterar as nomeclaturas padrões todas as barreiras do sistema vão sofrer alteração.':
            'Ao alterar as nomeclaturas padrões todas as barreiras do sistema vão sofrer alteração.',
        'nomeclaturas padrões': 'nomeclaturas padrões',
        'Novas nomeclaturas': 'Novas nomeclaturas',
        Entity: 'Entidade',
        CONTEXT: 'CONTEXTO',
        method: 'método',
        'update mode': 'modo de atualização',
        'escalation factor': 'fator de escalonamento',
        'id (escalation factor)': 'id (fator de escalonamento)',
        contribution: 'contribuição',
        'principal barrier': 'barreira principal',
        'id (principal barrier)': 'id (barreira principal)',
        'escalation factor control barrier': 'barreira de controle do fator de escalonamento',
        'id (e.f. control barrier)': 'id (barreira de controle de f.e.)',
        'Select the context to view an audit report': 'Selecione o contexto para visualizar um relatório de auditoria',
        'Escalation Factor Control Barrier': 'Barreira de Controle de F.E.',
        'Type to search for barrier name': 'Digite para pesquisar por nome de barreira',
        'Type to search for control barrier name': 'Digite para pesquisar por nome de barreira de controle',
        'Type to search for escalation factor name': 'Digite para pesquisar por nome de fator de escalonamento',
        'Type to search for top event name': 'Digite para pesquisar por nome de evento topo',
        'Engineering Audit': 'Auditoria de Engenharia',
        'threat id': 'id da ameaça',
        'consequence id': 'id da consequência',
        'top event id': 'id do evento topo',
        'effectiveness bottom': 'eficácia inferior',
        'effectiveness top': 'eficácia superior',
        'Type to search for threat name': 'Digite para pesquisar por nome de ameaça',
        'Type to search for consequence name': 'Digite para pesquisar por nome de consequência',
        'Select...': 'Selecione...',
        'Barrier Status Nomenclature Change': 'Alteração da Nomenclatura de Status de Barreiras',
        'The system allows you to change the default nomenclature used for barrier status. Default colors cannot be changed.':
            'O sistema possibilita a alteração da nomenclatura padrão utilizada no status de barreiras. As cores padrão não podem ser alteradas.',
        'WARNING: ': 'ATENÇÃO: ',
        Information: 'Informação',
        'Changes on the default nomenclature will affect all barriers in the system.':
            'Alterações na nomenclatura padrão afetarão todas as barreiras no sistema.',
        'Default nomenclature': 'Nomenclatura padrão',
        'New nomenclature': 'Nova nomenclatura',
        Nomenclature: 'Nomenclatura',
        'New Status': 'Novo Status',

        /* Operations */
        Delete: 'Excluir',
        DeleteAlarm: 'Excluir',
        Operations: 'Operações',
        Select: 'Selecione',
        'Alarm groups': 'Grupos de Alarme',
        'New Operation': 'Nova Operação',
        'Delete operation': 'Deletar operação',
        'There are no operations yet': 'Ainda não há operações',
        'Create new operation': 'Criar nova operação',
        'Edit Operation': 'Editar Operação',
        'The name is used to identify the operation.': 'O nome é utilizado para identificar a operação.',
        'Operation name': 'Nome da operação',
        'Unable to fetch operations.': 'Não foi possível recuperar as operações.',
        'Operation created successfully.': 'Operação criada com sucesso.',
        'Unable to create operation.': 'Não foi possível criar a operação.',
        'Operation updated successfully.': 'Operação atualizada com sucesso.',
        'Unable to update operation.': 'Não foi possível atualizar a operação.',
        'Are you sure you want remove the operation': 'Tem certeza que quer remover a operação',
        'successfully deleted.': 'deletada com sucesso',
        'If you really want to delete the operation, type': 'Se realmente quer deletar a operação, digite',

        /* ALARMS */
        or: 'ou',
        'The alarms group was updated successfully.': 'O grupo de alarmes foi atualizado com sucesso.',
        'The alarms group was deleted successfully.': 'O grupo de alarmes foi excluido com sucesso',
        'If you really want to delete the alarm group, type':
            'Se você realmente deseja remover o grupo de alarme, digite',
        'Delete alarm group': 'Excluir grupo de alarme',
        'Alarm Group Configuration': 'Configuração de Grupo de Alarme',
        WELCOME: 'BEM VINDO',
        'Here you can create groups, edit groups and add groups to bowties.':
            'Aqui você pode criar grupos, editar grupos e adicionar grupos a bowties.',
        'New Group': 'Novo Grupo',
        'Alarms Configurations': 'Configurações de Alarmes',
        'Group Edition': 'Edição de Grupo',
        EDITION: 'EDIÇÃO',
        Group: 'Grupo',
        '4Group': 'Grupo',
        GROUP: 'GRUPO',
        Users: 'Usuários',
        USERS: 'USUÁRIOS',
        RESPONSIBLE: 'RESPONSÁVEL',
        Subscriptions: 'Subscrições',
        'Save group without users': 'Salvar grupo sem usuários',
        'Are you sure you want save this group without any associated users?':
            'Tem certeza que quer salvar este grupo sem usuários associados?',
        'You can add users editing this group later.': 'Você poderá adicionar usuários mais tarde ao editar o grupo.',
        Confirm: 'Confirmar',
        'Are you sure you want remove the alarm group': 'Tem certeza que você deseja remover o grupo de alarme',
        'Here you can customize your subscriptions, notifications and reports.':
            'Aqui você pode  customizar suas inscrições, notificações e relatórios.',
        'Every option you subscribe to will reflect on all notification settings.':
            'Toda opção que você se inscrever refletirá em toda sua configuração de notificação.',
        'Email Notifications': 'Notificações via Email',
        'If you choose to receive email notifications, all the items you subscribed will be send by email in addition to system notifications.':
            'Se você optar por receber notificações por e-mail, todos os itens que você assinou serão enviados por e-mail, além das notificações do sistema.',
        'Sounds Notifications': 'Notificações Sonoras',
        'If you choose to receive sound notifications, all the items you subscribed will be send by sound in addition to system notifications.':
            'Se você optar por receber notificações sonoras, todos os itens que você assinou serão enviados por som, além das notificações do sistema.',
        'Receive email notifications': 'Receber notificações via email',
        'Receive sounds notifications': 'Receber notificações sonoras',
        'Send Test email': 'Enviar email de teste',
        'Send Test sound': 'Enviar teste sonoro',
        'unseen alarms': 'alarmes não visualizados',
        'There are': 'Existem',
        'detected alarms': 'alarmes detectados',
        'Filter Operation and Filter Severity': 'Filtrar Operações e Filtrar Serevidade',
        'Go to Alarms': 'Ir para Alarmes',
        'Selected Filters: ': 'Filtros selecionados: ',
        'Clear all': 'Limpar tudo',
        'had a ': 'tem um ',
        FATAL: 'CRÍTICO',
        'FATAL event detected': 'evento CRÍTICO detectado',
        'Last triggered': 'Último disparo',
        'Diagram view': 'Visualizar diagrama',
        'Alert on': 'Alerta em',
        Acknowledge: 'Reconhecimento',
        'Save acknowledge': 'Salvar reconhecimento',
        'BOWTIE CONTEXT:': 'CONTEXTO DE BOWTIE:',
        'Trigger Log': 'Registro de Disparo',
        'triggers in the last month single': 'disparo no último mês',
        'triggers in the last month': 'disparos no último mês',
        'ALERTS BY DAY': 'ALERTAS POR DIA',
        'Last 30 days': 'Últimos 30 dias',
        'triggered on the last 7 days': 'disparados nos últimos 7 dias',
        'had an ': 'teve um ',
        TOP_EVENT: 'Evento Topo',
        'Select an alarm to see its details.': 'Selecione um alarme para ver seus detalhes.',
        'Info Alerts': 'Alertas Informativos',
        'Warn Alerts': 'Alertas de Aviso',
        'Error Alerts': 'Alertas de Erro',
        'Fatal Alerts': 'Alertas Críticos',
        'You need select a bowtie to configure a group.': 'Você precisa selecionar um bowtie para configurar um grupo.',
        'Please, input a name for alarm group.': 'Por favor, digite um nome para o grupo de alarmes.',
        'Please, input a description for alarm group.': 'Por favor, digite uma descrição para o grupo de alarmes.',
        info: 'informação',
        warn: 'aviso',
        error: 'erro',
        fatal: 'crítico',
        'Alarm Details': 'Detalhes de Alarme',
        'True Alarm': 'Alarme Verdadeiro',
        'False Alarm': 'Alarme Falso',
        'Dismiss Alarm': 'Alarme Descartado',
        'Missing Alarm': 'Alarme Perdido',
        'For a semi-qualitative bowties, qualitative barriers are used.':
            'Para bowties semi qualitativos, somente são utilizadas barreira qualitativas',

        /*  IMPORT/EXPORT  */

        'Export data': 'Exportar dados',
        'Import data': 'Importar dados',
        'Associate data': 'Associar dados',
        'Are you sure you want to upload': 'Tem certeza que quer carregar o arquivo',
        'Confirm association': 'Confirmar associação',
        'Confirm import': 'Confirmar importação',
        'Upload csv file': 'Carregar arquivo csv',
        ' Select .csv file': ' Selecione arquivo .csv',
        'Export incomplete data': 'Exportar dados incompletos',
        'Are you sure you want to export': 'Tem certeza que quer exportar repositório de',
        'data with incomplete arguments? ': 'com dados incompletos? ',
        'We suggest you review': 'Sugerimos que revise',
        'and complete them before you export. If you want to export it anyway, click on "Confirm incomplete export".':
            'e complete antes de exportar. Se quer realizar a exportação mesmo assim, clique em "Confirmar exportação incompleta".',
        'risk diagram': 'diagram de risco',
        'risk diagrams': 'diagramas de risco',
        barrier: 'barreira',
        barriers: 'barreiras',
        yourf: 'suas',
        yourm: 'seus',
        'Confirm incomplete export': 'Confirmar exportação incompleta',
        'The alarms group was created successfully.': 'O grupo de alarmes foi criado com sucesso.',
        'Alarms Notification Settings': 'Configuração de notificações de alarmes',
        view: 'vizualizar',
        Severity: 'Gravidade',

        /*  END  */

        name: 'nome',
        'barrier category': 'Caregoria da barreira',
        supervisor: 'supervisor',
        'Manual Interaction Initial PFD': 'Interação manual PFD inicial',
        'Manual Interaction Initial Fequency': 'Interação manual frequência inicial',
        'Manual Interaction Final PFD': 'Interação manual PFD final',
        'Manual Interaction MOC': 'Interação manual MOC',
        'Manual Interaction Responsible': 'Interação manual responsável',
        'update mode code': 'código do modo de atualização',

        High: 'Alta',
        Low: 'Baixa',
        Required: 'Obrigatório',
        'Value Between 0 and 100': 'Valor entre 0 e 100',
        'Alarms notifications settings updated succesfully.':
            'Configuração de notificações de alarmes atualizada com sucesso.',
        'Alarms notifications settings created succesfully.':
            'Configuração de notificações de alarmes criada com sucesso.',
        // 'Alarms notifications settings created succesfully.': 'Configuração de notificações de alarmes criada com sucesso.',
        'No acknowledge': 'Sem reconhecimento',
        'false alarm': 'Alarme falso',
        'true alarm': 'Alarme verdadeiro',
        'missing alarm': 'Alarme perdido',
        'dismiss alarm': 'Alarme descartado',
        'The semi-qualitative values were configured successfully':
            'Os valores do semi qualitativo foram configurados com sucesso',
        'The semi-qualitative values were saved successfully':
            'Os valores do semi qualitativo foram salvos com sucesso',
        'Please be aware that, if you use the semi-qualitative preset, your status threshold will change considerably. All statuses that are not Active or Inactive will be disabled':
            'Favor atentar para o fato de que, caso você utilize a pré-configuração semi qualitativa, seus limites de status sofrerão mudanças consideráveis. Todos os status que não forem Ativo ou Inativo serão desativados',
        'SEMI-QUALITATIVE CONFIGURATION': 'CONFIGURAÇÃO DO SEMI QUALITATIVO',
        'Semi-qualitative preset': 'Pré-definição semi qualitativa',
        'If you want to use this barrier category on a semi-qualitative bowtie, click on this preset to configure the quantitative, qualitative, and quantization values. The preset works if you want to use active and inactive status only. For the use of a third status, please refer to the values on the user guide.':
            'Se você quer usar essa categoria de barreira em bowties semi qualitativos, clique nesta pré-configuração para setar os valores de quantitativo, qualitativo e quantizador. Essa pré-configuração funciona para o uso do status ativo e inativo apenas. Para o uso de um terceiro status, consulte os valores no manual do usuário.',
        'These pre-settings work if you want to use active and inactive status, for the use of a third status, see the user guide':
            'Essa pré configuração funciona para o uso do status ativo e inativo, para o uso de um terceiro status, consulte os valores no manual do usuário',
        'Your data has been uploaded': 'Seus dados foram importados',
        'Your data is being uploaded': 'Seus dados estão sendo importados',
        'Data successfully uploaded.': 'Dados processados com sucesso.',
        'Please wait while we load your file. Do not close the page or exit the system during the process.':
            'Aguarde enquanto carregamos seu arquivo. Não feche a página ou saia do sistema durante o processo.',
        'Are you sure you want to cancel the data import?': 'Tem certeza de que deseja cancelar a importação de dados?',
        'The data already loaded will not be saved.': 'Os dados já carregados não serão salvos.',
        'You are about to import bowtie data.': 'Você está prestes a exportar dados de bowties.',
        'Please consider that importing data is a process that needs to be done thoroughlly or it will result in an error.':
            'Considere que a importação de dados é um processo que precisa ser feito minuciosamente ou resultará em um erro.',
        'We advise you to read the ': 'Aconselhamos a leitura do ',
        'Import Guide': 'Guia de Importação',
        ' and use the ': ' e o uso do ',
        Template: 'Template',
        ' Select .xlsx file': ' Selecione o arquivo .xlsx',
        'Confirm cancel': 'Confirmar cancelamento',
        steps: 'etapas',
        Complete: 'Completo',
        'Fix the error in your import sheet and try again.':
            'Corrija o erro em seu arquivo de importação e tente novamente.'
    }
}
